import { createReducer, Action, on } from '@ngrx/store';
import { uniq } from 'lodash-es';

import { PanelActions } from './panel.actions';
import { PanelState, PanelViewId } from './panel.state';
import { XRayViews } from '../../features/market-comparison/models/paragraph-diff.model';
import { measureReducer } from '../../features/shared/utils/runtime-reducer-stats';

export const initialState: PanelState = {
  activePanelViews: [PanelViewId.Summary, PanelViewId.Document],
  alignState: 'vertical',
  sectionSizes: {
    document: '33%',
    summary: '34%',
    termExplorer: '33%',
    jsonEditor: '33%',
    datapoint: '0',
    similarParagraph: '0',
    clipping: '0',
    tables: '0',
    timeline: '0',
    positions: '0',
  },
  xRayViews: XRayViews.Plain,
};

const featureReducer = measureReducer(
  createReducer(
    initialState,
    on(PanelActions.SetAlignState, (state, action): PanelState => ({ ...state, alignState: action.state })),
    on(PanelActions.SetCalculatedViewerState, (state, action): PanelState => {
      return {
        ...state,
        activePanelViews: action.state,
      };
    }),
    on(PanelActions.SetCalculatedSmalViewerState, (state, action): PanelState => {
      return {
        ...state,
        smallViewPanel: action.state,
      };
    }),
    on(PanelActions.SetSectionSizes, (state, action): PanelState => ({ ...state, sectionSizes: action.sizes })),
    on(PanelActions.PatchCalculatedViewerState, (state, action): PanelState => {
      const hiddenPanels = action.patch.filter((p) => !p.show).map((p) => p.panel);
      return {
        ...state,
        activePanelViews: uniq([
          ...state.activePanelViews?.filter((ap) => !hiddenPanels.includes(ap)),
          ...action.patch.filter((p) => p.show).map((p) => p.panel),
        ]),
      };
    }),
    on(PanelActions.SetXRayViews, (state, action): PanelState => ({ ...state, xRayViews: action.view })),
  ),
);

export function reducer(state: PanelState | undefined, action: Action) {
  return featureReducer(state, action);
}
